<template>
  <div class="item-drop-zone" @dragenter.self="onDragenter" @dragleave.self="onDragleave" @drop="onDragleave"
    :class="[{ 'drag-hover': todoDragHover }]">
    <div class="todo-item-container" :class="{ 'compact-view': compactView }" ref="itemContainer">
      <div v-if="!editing" class="inline-todo-item d-flex flex-column" @mouseenter="showToDoItem" @dblclick="editToDo">
        <div class="d-flex">
          <span class="noselect item-text" :class="{ 'checked-todo': toDo.checked, 'compact-view': compactView }" :style="priorityStyle"
            style="flex-grow: 1">
            <span class="status-dot" :class="'status-dot-' + todoStatus"></span>
            <span class="priority-badge" :class="'priority-' + priorityLevel" v-if="priorityLevel">{{ priorityLabel }}</span>
            <span v-html="todoText"></span>
            <span v-if="!compactView" class="item-time mx-2" :class="{ 'checked-todo': toDo.checked }"> {{
                timeFormat(toDo.time)
            }} <div class="alarm-indicator" :class="{ 'show-alarm-indicator': notificationIndicator && toDo.alarm }">
              </div></span>
          </span>
          <span v-if="compactView" class="item-time" :class="{ 'checked-todo': toDo.checked }"> {{ timeFormat(toDo.time)
          }}
            <div class="alarm-indicator" :class="{ 'show-alarm-indicator': notificationIndicator && toDo.alarm }"></div>
          </span>
        </div>
      </div>
      <input v-show="editing" class="edit todo-input" type="text" v-model="text" ref="toDoEditInput" @blur="doneEdit()"
        @keyup.enter="doneEdit()" @keyup.esc="cancelEdit()" />
    </div>
  </div>
</template>

<script>
import toDoListRepository from "../repositories/toDoListRepository";
import moment from "moment";
import linkifyStr from 'linkify-string';

export default {
  components: {},
  props: {
    toDo: { required: true, type: Object },
    index: { required: true, type: Number },
    toDoListId: { required: true, type: String },
  },
  data() {
    return {
      editing: false,
      text: this.toDo.text,
      todoDragHover: false,
      options: { target: '_blank', defaultProtocol: 'https' }
    };
  },
  methods: {
    editToDo: function () {
      this.text = this.toDo.text;
      this.editing = true;
      this.$nextTick(function () {
        this.$refs.toDoEditInput.focus();
        this.$refs.toDoEditInput.select();
      });
      document.getElementById("todo-item-active").style.display = 'none';
    },
    doneEdit: function () {
      this.editing = false;
      this.$store.commit("updateTodo", {
        toDoListId: this.toDoListId,
        index: this.index,
        text: this.text,
      });
      toDoListRepository.update(this.toDoListId, this.$store.getters.todoLists[this.toDoListId]);
    },
    cancelEdit: function () {
      this.text = this.toDo.text;
      this.editing = false;
    },
    onDragenter: function () {
      this.todoDragHover = true;
    },
    onDragleave: function () {
      this.todoDragHover = false;
    },
    timeFormat: function (date) {
      if (date) {
        return moment(date, "HH:mm").format("HH:mm");
      }
    },

    showToDoItem: function () {
      var activeTodo = {
        toDo: this.toDo,
        index: this.index,
        toDoListId: this.toDoListId,
        edit: this.editToDo,
        container: this.$refs.itemContainer
      };
      this.$store.commit('setActiveTodo', activeTodo);

      const activeTodoItem = document.getElementById("todo-item-active");
      this.$nextTick(function () {
        const bounding = this.$refs.itemContainer.getBoundingClientRect();
        const popupWidth = Math.max(bounding.width + 24, 360);
        activeTodoItem.style.width = `${popupWidth}px`;
        activeTodoItem.style.top = `${bounding.y}px`;

        // 右侧边界检查：防止面板超出视口右侧
        const margin_right = 10;
        var leftOffset = bounding.x;
        var rightOverflow = parseInt(leftOffset) + popupWidth + margin_right - parseInt(window.innerWidth);
        if (rightOverflow > 0) leftOffset = parseInt(window.innerWidth) - popupWidth - margin_right;
        activeTodoItem.style.left = `${leftOffset}px`;

        activeTodoItem.style.display = `block`;
        const margin_bottom = 10;
        var offset = parseInt(window.innerHeight) - (parseInt(bounding.y) + parseInt(activeTodoItem.offsetHeight)) - margin_bottom;
        if (offset < 0) activeTodoItem.style.top = `${bounding.y + offset}px`;
      });
    },
  },
  computed: {
    todoText: function () {
      return linkifyStr(this.toDo.text, this.options);
    },
    compactView: function () {
      return this.$store.getters.config.compactView;
    },
    notificationIndicator: function () {
      return this.$store.getters.config.notificationIndicator;
    },
    todoStatus: function () {
      if (this.toDo.status) return this.toDo.status;
      return this.toDo.checked ? "done" : "pending";
    },
    firstChar: function () {
      const text = (this.toDo.text || "").trim();
      if (!text) return "?";
      return text.charAt(0).toUpperCase();
    },
    priorityLevel: function () {
      return this.toDo.priorityLevel || "L3";
    },
    priorityLabel: function () {
      const labels = { L1: "紧急", L2: "重要", L3: "常规", L4: "宽松", L5: "待定" };
      return labels[this.priorityLevel] || "";
    },
    priorityStyle: function () {
      const sizes = { L1: "1.05rem", L2: "0.95rem", L3: "0.865rem", L4: "0.78rem", L5: "0.72rem" };
      return { fontSize: sizes[this.priorityLevel] || "0.865rem" };
    },
  }
};
</script>

<style scoped lang="scss">
.todo-item-container {
  border-bottom: 1px solid #eaecef;
  min-height: 26px;
  z-index: 1;

  .dark-theme & {
    border-bottom: 1px solid #30363d;
  }
}

.dragging-item .item-drop-zone * {
  pointer-events: none;
}

.todo-input {
  line-height: 1.3rem;
  width: 100%;
  border: none;
  font-size: 0.865rem;

  &:focus {
    outline: none;
  }
}

.item-text {
  transition: width 2s, height 2s, transform 2s;
  width: 1rem;
  min-height: 1.2rem;
  line-height: 1.3rem;
  font-size: 0.865rem;
  margin: 2px 0px 2px 0px;
  padding: 0 3px 0 7px;
}

.item-text.compact-view {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 1.2rem;
}

.item-time {
  transition: width 2s, height 2s, transform 2s;
  height: 1.2rem;
  line-height: 1.3rem;
  font-size: 0.865rem;
  margin: 2px 0px 2px 0px;
  padding: 0 2px 0 0px;
  opacity: 0.6;
}

.item-time.checked-todo {
  opacity: unset;
}

.time-details {
  opacity: 0.6;
  display: inline;
  margin-left: 5px;
}

.checked-todo {
  color: #acacac;
  text-decoration: line-through;

  .dark-theme & {
    color: #636363;
  }
}

.checked-sub-task {
  color: #c4c4c4;
  text-decoration: line-through;

  .dark-theme & {
    color: #3a3a40;
  }

  input {
    opacity: 0.5;
  }
}

.drag-hover {
  color: rgba(157, 157, 157, 0.43);
  box-shadow: rgb(244, 243, 243) 0px 0px 4px 1px inset;
  background-color: rgb(250, 249, 249);
}

.dark-theme .drag-hover {
  color: rgb(69, 69, 69);
  box-shadow: #0b0d12 0px 0px 4px 1px inset;
  background-color: #0c0d14;
}

.sub-tasks {
  list-style: none;
  padding: 0px;
  font-size: 0.865rem;

  li {
    margin: 0px 10px 0px 10px;
  }

  li:last-child {
    margin: 0px 10px 10px 10px;
  }

  input {
    min-width: 14px;
    width: 14px;
    min-height: 14px;
    height: 14px;
    margin-right: 8px;
  }

  label {
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.cicle-icon {
  font-size: 10px;
  margin-right: 5px;
}

.status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  min-width: 10px;
  border-radius: 50%;
  margin-right: 5px;
  flex-shrink: 0;
}
.status-dot-pending { background-color: #dc3545; }
.status-dot-in_progress { background-color: #0d6efd; }
.status-dot-done { background-color: #28a745; }
.status-dot-cancelled { background-color: #fd7e14; }

.bi-check-circle-fill,
.bi-check-circle {
  opacity: 0.7;
}

.checked-green {
  color: #28a745;
  opacity: 1;
}

/* 优先级徽章 */
.priority-badge {
  display: inline-block;
  font-size: 0.62rem;
  font-weight: 600;
  padding: 0 5px;
  margin-right: 4px;
  border-radius: 3px;
  line-height: 1.4;
  vertical-align: middle;
}
.priority-L1 { background: #dc3545; color: #fff; }
.priority-L2 { background: #fd7e14; color: #fff; }
.priority-L3 { background: #0d6efd; color: #fff; }
.priority-L4 { background: #28a745; color: #fff; }
.priority-L5 { background: #6c757d; color: #fff; }

.dark-theme .priority-L1 { background: #e35d6b; }
.dark-theme .priority-L2 { background: #ff9f43; }
.dark-theme .priority-L3 { background: #4d9bff; }
.dark-theme .priority-L4 { background: #51cf66; }
.dark-theme .priority-L5 { background: #868e96; }

.todo-item-container.compact-view {
  height: 26px;
}
</style>
